import React, { useContext, useState } from "react";
import EventContext from "../event/eventContext";
import { withRouter } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

const CreateExercise = props => {
  const eventContext = useContext(EventContext);
  const [showPotrdi, setShowPotrdi] = useState(false);
  const [btnDis, setBtnDis] = useState(false);
  const { addExercise } = eventContext;
  const [newEvent, setNewEvent] = useState({
    id: uuidv4(),
    lessonInstructionsOne: "Preglej sklope in sledi navodilom"
  });

  const {
    lessonClassName,

    lessonTitle,
    lessonInstructionsOne,
    ytLink,
    ytLinkInfo,
    lessonPartOneInstructions,
    lessonLinkFourInfo,
    lessonLinkThreeInfo,
    lessonLinkTwoInfo,
    lessonLinkOneInfo,
    lessonPartOneSrc,
    lessonLinkOne,
    lessonLinkTwo,
    lessonLinkThree,
    lessonLinkFour
  } = newEvent;

  const onSubmit = e => {
    e.preventDefault();
    addExercise(newEvent);
    setShowPotrdi(true);
    setBtnDis(true);
  };
  return (
    <div>
      <div className='create-title'>DODAJ VAJO</div>
      <form className='form-create' onSubmit={e => onSubmit(e)}>
        <section className='create-form-container'>
          <h1 className='form-title'>Splošni podatki</h1>
          <label for='vrsta' className='form-label'>
            Izberi razred
          </label>
          <select
            className='form-select'
            value={lessonClassName}
            onChange={e => {
              setNewEvent({ ...newEvent, lessonClassName: e.target.value });
            }}
          >
            <option value='0. razred'>Izberi razred</option>
            <option value='1.'>1. razred</option>
            <option value='2.'>2. razred</option>
            <option value='3.'>3. razred</option>
            <option value='4.'>4. razred</option>
            <option value='5.'>5. razred</option>
            <option value='6.'>6. razred</option>
            <option value='7.'>7. razred</option>
            <option value='8.'>8. razred </option>
            <option value='9.'>9. razred </option>
          </select>

          <label for='venue' className='form-label'>
            Naslov vaje
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonTitle}
            onChange={e => {
              setNewEvent({ ...newEvent, lessonTitle: e.target.value });
            }}
          />
        </section>
        <section className='create-form-container'>
          <h1 className='form-title'>Opis vaje</h1>
          <label for='vrsta' className='form-label'>
            Kratek opis vaje
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonInstructionsOne}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonInstructionsOne: e.target.value
              });
            }}
          />
        </section>
        <section className='create-form-container'>
          <h1 className='form-title-small'>Youtube video</h1>
          <label for='vrsta' className='form-label'>
            Navodila sklopa
          </label>
          <input
            type='text'
            className='form-input'
            value={ytLinkInfo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                ytLinkInfo: e.target.value
              });
            }}
          />
          <label for='vrsta' className='form-label'>
            Vir (google url)
          </label>
          <input
            type='text'
            className='form-input'
            value={ytLink}
            onChange={e => {
              setNewEvent({ ...newEvent, ytLink: e.target.value });
            }}
          />
          <h1 className='form-title-small'>1. SKLOP</h1>
          <label for='vrsta' className='form-label'>
            Google vaje
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonPartOneInstructions}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonPartOneInstructions: e.target.value
              });
            }}
          />
          <label for='vrsta' className='form-label'>
            Vir (google url)
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonPartOneSrc}
            onChange={e => {
              setNewEvent({ ...newEvent, lessonPartOneSrc: e.target.value });
            }}
          />
          <h1 className='form-title-small'>POVEZAVE</h1>
          <label for='vrsta' className='form-label'>
            Opis 1. povezave
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkOneInfo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkOneInfo: e.target.value
              });
            }}
          />
          <label for='vrsta' className='form-label'>
            1. povezava
          </label>

          <input
            type='text'
            className='form-input'
            value={lessonLinkOne}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkOne: e.target.value
              });
            }}
          />
          <br></br>
          <br></br>
          <label for='vrsta' className='form-label'>
            Opis 2. povezave
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkTwoInfo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkTwoInfo: e.target.value
              });
            }}
          />

          <label for='vrsta' className='form-label'>
            2. povezava
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkTwo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkTwo: e.target.value
              });
            }}
          />
          <br></br>
          <br></br>
          <label for='vrsta' className='form-label'>
            Opis 3. povezave
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkThreeInfo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkThreeInfo: e.target.value
              });
            }}
          />
          <label for='vrsta' className='form-label'>
            3. povezava
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkThree}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkThree: e.target.value
              });
            }}
          />
          <br></br>
          <br></br>
          <label for='vrsta' className='form-label'>
            Opis 4. povezave
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkFourInfo}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkFourInfo: e.target.value
              });
            }}
          />
          <label for='vrsta' className='form-label'>
            4. povezava
          </label>
          <input
            type='text'
            className='form-input'
            value={lessonLinkFour}
            onChange={e => {
              setNewEvent({
                ...newEvent,
                lessonLinkFour: e.target.value
              });
            }}
          />

          {btnDis ? (
            <button className='form-button' disabled>
              Potrdi
            </button>
          ) : (
            <button className='form-button'>Potrdi</button>
          )}
          {showPotrdi ? (
            <h1 style={{ fontSize: "3rem", marginTop: "3rem" }}>
              Uspešno oddana vaja
            </h1>
          ) : (
            false
          )}
        </section>
      </form>
    </div>
  );
};

export default CreateExercise;
